import App from 'app/app.js';

function LtPotraitGalleryCtrl($scope, $filter, LooksStore, ContentStore) {
  this.looksCategories = [];
  this.leftNavVisible = false;
  this.rightNavVisible;
  this.mobNavEl;
  this.isViewOpen = true;
  this.selectedCategory;
  var self = this;
  this.promotedLooks = LooksStore.promotedLooks;
  this.isPromotedLooksAvailable = false;
  this.promoted_looks = [];

  this.getLookCategories = function () {
    this.looksCategories = R.map(function (lookCategory) {
      return {
        lookCategory: lookCategory,
        lookName: $filter('ltTranslateFilter')(lookCategory)
      };
    })(LooksStore.getLookCategories());

    if (this.looksCategories[0].lookCategory == 'FeaturedLooks') {
      return;
    } else if (this.looksCategories[0].lookCategory !== 'FeaturedLooks') {
      var index = R.findIndex(R.propEq('lookCategory', 'FeaturedLooks'))(this.looksCategories);
      if (index > 0) {
        var obj = this.looksCategories[0];
        this.looksCategories[0] = this.looksCategories[index];
        this.looksCategories[index] = obj;
      } else {
        return;
      }
    }
  };

  window.addEventListener(
    'resize',
    function (event) {
      self.getLeftAndRightNavVisibility();
    },
    true
  );

  this.selectLookCategroy = function (category) {
    var menuBtn = document.getElementsByClassName('heading-text');
    function addEv(value) {
      value.addEventListener(
        'click',
        function () {
          value.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        },
        false
      );
    }
    R.forEach(addEv, menuBtn);
    this.selectedCategory = category;
    self.getLeftAndRightNavVisibility();
  };

  this.init = function () {
    this.allLooks = LooksStore.getLooks();
    this.getLookCategories();
    this.promoted_looks = LooksStore.getPromotedLookList();
    this.isPromotedLooksAvailable = LooksStore.promotedLooksCheck();
    if (this.isPromotedLooksAvailable) {
      this.isPromotedLooks();
      this.getPromotedLooks();
    }
    var unwatchLook = $scope.$watch(
      'choosedLook',
      function (choosedLook) {
        if (!choosedLook || !choosedLook.category) {
          this.selectedCategory = this.looksCategories[0].lookCategory;
        } else {
          this.selectedCategory = choosedLook.category;
        }
      }.bind(this)
    );
    $scope.$on('$destroy', function () {
      unwatchLook();
    });
  };

  this.getLeftAndRightNavVisibility = function () {
    setTimeout(function () {
      self.mobNavEl = document.getElementById('second-head-mobile');
      self.mebileMenus = document.getElementsByClassName('mobile-items');
      var width = 0;
      R.forEach(function (menu) {
        if (menu) {
          width += menu.clientWidth;
        }
      })(self.mebileMenus);
      if (self.mobNavEl && width < self.mobNavEl.offsetWidth) {
        self.rightNavVisible = false;
        $scope.$apply(function () {});
      } else {
        self.rightNavVisible = true;
        $scope.$apply(function () {});
      }
      if (
        self.mobNavEl &&
        self.rightNavVisible &&
        self.looksCategories[0] &&
        self.selectedCategory != self.looksCategories[0].lookCategory
      ) {
        self.leftNavVisible = true;
        $scope.$apply(function () {});
      } else {
        self.leftNavVisible = false;
        $scope.$apply(function () {});
      }
    }, 0);
  };

  angular.element(document).ready(function () {
    self.getLeftAndRightNavVisibility();
  });

  this.moveLeft = function () {
    this.mobNavEl.scrollLeft -= 100;
    this.rightNavVisible = true;
    if (this.mobNavEl.scrollLeft === 0) {
      this.leftNavVisible = false;
    } else {
      this.leftNavVisible = true;
    }
  };

  this.changeLook = function (look) {
    look.category = this.selectedCategory;
    $scope.changeLook({
      look: look
    });
    if (document.getElementById('image')) {
      document.getElementById('image').scrollIntoView({ behavior: 'smooth' });
    }
  };

  this.moveRight = function () {
    var width = 0;
    this.mobNavEl = document.getElementById('second-head-mobile');
    this.mebileMenus = document.getElementsByClassName('mobile-items');
    R.forEach(function (menu) {
      width += menu.clientWidth;
    })(this.mebileMenus);
    this.mobNavEl.scrollLeft += 100;
    this.leftNavVisible = true;
    var left = this.mobNavEl.scrollLeft;
    var offsetWidth = this.mobNavEl.offsetWidth;
    var scrollWidth = this.mobNavEl.scrollWidth;
    var viewWidth = scrollWidth - offsetWidth - 1;
    if (left >= viewWidth) {
      this.rightNavVisible = false;
    } else {
      this.rightNavVisible = true;
    }
  };

  this.openGalleryView = function () {
    this.isViewOpen = !this.isViewOpen;
  };

  this.getGalleriesTooltipText = function () {
    return ContentStore.getContent('DETAIL', 'PORTRAIT_GALLERIES_TOOLTIP');
  };

  this.isPromotedLooks = function () {
    this.looksCategories.forEach(function (look, index) {
      if (self.promoted_looks.includes(look.lookCategory)) {
        look.isPromotedLook = true;
      }
    });
  };

  this.getPromotedLooks = function () {
    var list = [];
    this.promoted_looks.forEach(function (lookName) {
      self.looksCategories.forEach(function (look) {
        if (lookName == look.lookCategory) {
          list.push(look);
        }
      });
    });

    self.looksCategories.forEach(function (look) {
      if (!self.promoted_looks.includes(look.lookCategory)) {
        list.push(look);
      }
    });

    this.looksCategories = list;
  };

  this.getPromotedLookStyles = function (look) {
    if (look.isPromotedLook) {
      var promotedLookStyles = {};
      var newCategory = 'LOOK_CATEGORY_' + look.lookCategory.toUpperCase() + '_STYLE';
      var className = $filter('ltTranslateFilter')(newCategory);
      if (className) {
        var list = className.split(',');
        promotedLookStyles.iconClass = list[0];
        promotedLookStyles.color = list[1];
        promotedLookStyles.fontWeight = list[2];
      } else {
        promotedLookStyles.iconClass = '';
        promotedLookStyles.color = '';
        promotedLookStyles.fontWeight = '';
      }
      return promotedLookStyles;
    }
  };
}

App.controller('LtPotraitGalleryCtrl', ['$scope', '$filter', 'LooksStore', 'ContentStore', LtPotraitGalleryCtrl]);
